"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrashcanOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M27 6h-5.38l-1.45-2.9A1.99 1.99 0 0018.38 2h-4.76a1.99 1.99 0 00-1.8 1.1L10.39 6H5a1 1 0 000 2h1v20a2 2 0 002 2h16a2 2 0 002-2V8h1a1 1 0 000-2zM13.62 4h4.76l1 2h-6.76zM24 28H8V8h16z"/><path d="M13 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1zM19 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1z"/>';
var TrashcanOutlineSVG = function TrashcanOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TrashcanOutlineSVG = TrashcanOutlineSVG;
TrashcanOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrashcanOutlineSVG);
exports.default = _default;